import styled from "styled-components";
import { RATypography } from "@/components/customs";
import { SvgCheckCircle, SvgInvited } from "@/assets/icons";

export function RAEmptyLegLabel({ label = {} }) {
	const _renderLabel = () => {
		switch (label) {
			case "INVITED":
				return (
					<Label background="#2D2F5F">
						<SvgInvited />
						<RATypography variant="label4" color="#fff">
							INVITED
						</RATypography>
					</Label>
				);
			case "MATCH":
				return (
					<Label background="#10773F">
						<SvgCheckCircle />
						<RATypography variant="label4" color="#fff">
							MATCH
						</RATypography>
					</Label>
				);
			case "CREATED":
				return <></>;
			case "REQUESTED":
				return (
					<Label background="#10773F">
						<SvgCheckCircle />
						<RATypography variant="label4" color="#fff">
							REQUESTED
						</RATypography>
					</Label>
				);
			case "EXPIRED":
				return (
					<Label background="#A8A8A8">
						<SvgCheckCircle />
						<RATypography variant="label4" color="#fff">
							EXPIRED
						</RATypography>
					</Label>
				);
			default:
				return null;
		}
	};

	return _renderLabel();
}

const Label = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: 3px 8px;
	gap: 6px;
	min-width: 81px;
	min-height: 24px;
	background: ${(props) => props.background || "transparent"};
	border-radius: 6px 0px;
`;
